// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__L6BsP","modal-content":"styles_modal-content__UaVGL"};